import { RootState } from 'types/store';

export const isAuthenticatedSelector = (state: RootState) => state.auth.isAuthenticated;
export const isAuthenticationCompleteSelector = (state: RootState) => state.auth.isComplete;

export const appAccessCodeSelector = (state: RootState) => state.auth.appAccessCode;
export const isAppAccessCodeFailedSelector = (state: RootState) => state.auth.isAppAccessCodeFailed;

export const authTokenSelector = (state: RootState) => state.auth.authToken;
